import { combineReducers } from 'redux'

import deviceReducer from './deviceReducer'
import editorReducer from './editorReducer'
import currentPresetReducer from './currentPresetReducer'
import presetsReducer from './presetsReducer'
import userCurveReducer from './userCurveReducer'
import learnModeReducer from './learnModeReducer'
import preferencesReducer from './preferencesReducer'

const malletStationApp = combineReducers({
  device: deviceReducer,
  editor: editorReducer,
  currentPreset: currentPresetReducer,
  presets: presetsReducer,
  userCurves: userCurveReducer,
  learnMode: learnModeReducer,
  editorPreferences: preferencesReducer
})

export default  malletStationApp
/*
  // using combineReducers multiple times for nested reducers

  https://github.com/reactjs/redux/issues/738

  rootReducer = combineReducers({
    device: deviceReducer,
    editor: combineReducers({
      profile: combineReducers({
         info, // reducer function
         credentials // reducer function
      }),
      billing // reducer function
    }),
    // ... other combineReducers
  })
});
*/
